import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@material-ui/core';
import { IconButton } from '@projeccions-pdc/react-icon';
import ContentPicker from '../ContentPicker';
import { cloneDeep } from 'lodash';
import { getLocalizedName, createShareLink } from '../../../helpers';
import AppContext from '../../../AppContext';
import FileService from '../../../apiclients/FileService';
import ContentService from '../../../apiclients/ContentService';
import FileDeliveryService from '../../../apiclients/FileDeliveryService';
import { withStyles } from '@material-ui/core/styles';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import LocalizedStrings from '../../Localization/localization';
import Loader from '../Loader';
import Chip from '@material-ui/core/Chip';


const styles = theme => ({
    root: {
        zIndex: '1401!important',
    }
});

class AttachmentManager extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isContentPickerOpen: false,
            tempAttachments: this.parseToResource(props.attachments),
            showFileAdded: false,
            loadingDone: false,
        };
    }

    handleAddContentClick = () => {
        this.setState({ isContentPickerOpen: true });
    }

    handleCloseContentPicker = () => {
        this.setState({ isContentPickerOpen: false });
    }

    onAttachmentsChange = (newFiles) => {
        this.setState({ tempAttachments: newFiles, showFileAdded: true });
        if (this.timeout) clearTimeout(this.timeout);
        this.timeout = setTimeout(() => this.setState({ showFileAdded: false }), 1500);
    };

    prepareAttachmentsForShare = async () => {
        this.setState({ loadingDone: true });
        let newAttachments = cloneDeep(this.state.tempAttachments);
        for (let i = 0; i < newAttachments.length; i++) {
            let att = newAttachments[i];
            let attachment = await this.getShareUrl(att);
            newAttachments[i] = attachment;
        };

        newAttachments = newAttachments.filter((att) => {
            return att !== undefined;
        });
        this.props.onAttachmentsChange(newAttachments);
        this.setState({ loadingDone: false, tempAttachments: this.parseToResource(newAttachments) });
        this.handleCloseContentPicker();
    }

    getShareUrl = async (resource) => {

        let appContext = new AppContext();
        let lang = appContext.getLanguage();
        if (resource.url === undefined || resource.names === undefined) {
            if (resource.resourceType === 'file') {
                try {
                    let res = await FileService.shareFile(
                        resource.resourceId
                    );
                    return {
                        url: res.url,
                        name: res.filename,
                        identifier: 'file~' + resource.resourceId,
                        resourceSubtype: resource.resourceSubtype,
                        shareable: resource.shareable
                    };
                } catch (err) {
                    this.errorId = this.props.notify('error', `${getLocalizedName(lang, resource.names)} ${LocalizedStrings.errorShareable}`, this.errorId);
                    return undefined;
                }
            } else {
                let platformConfig = appContext.getPlatformConfig();

                let tempInDays = platformConfig.shareExpireInDays ? platformConfig.shareExpireInDays : 30;
                let now = new Date();
                let expireDate = now.setDate(now.getDate() + tempInDays);

                this.setState({ loading: true });
                let ids = [];
                let currentContent;
                try {
                    currentContent = await FileDeliveryService.getContent(resource.resourceId, undefined, undefined, undefined);
                } catch (err) {
                    console.log('err', err.message);
                    currentContent = {};
                }
                if (currentContent.children) {
                    ids = currentContent.children;
                }
                ids.push(resource.resourceId);

                try {
                    let response = await ContentService.shareContent(
                        ContentService.getShareURL(),
                        ids,
                        expireDate
                    );
                    let name = getLocalizedName(lang, resource.names);
                    let link = createShareLink(resource.resourceId, resource.resourceSubtype, name, response.shareToken);
                    return {
                        identifier: `${resource.resourceType}~${resource.resourceId}`,
                        resourceSubtype: resource.resourceSubtype,
                        name: name,
                        url: link,
                    };

                } catch (err) {
                    console.log(err.message);
                    this.errorId = this.props.notify('error', LocalizedStrings.errorShareLink, this.errorId);
                    return undefined;
                }

            }
        } else {
            let response;
            if (resource.resourceId !== undefined) {
                response = {
                    identifier: `${resource.resourceType}~${resource.resourceId}`,
                    resourceSubtype: resource.resourceSubtype,
                    name: getLocalizedName(lang, resource.names),
                    url: resource.url,
                };
            } else {
                response = resource;
            }
            return Promise.resolve(response);
        }

    }

    parseToResource = (attachments) => {
        return attachments.map((att) => {
            if (att.resourceId !== undefined) {
                return att;
            }
            let aux = att.identifier.split('~');

            return ({
                resourceId: aux[1],
                resourceType: aux[0],
                resourceSubtype: att.resourceSubtype,
                names: { default: att.name },
                url: att.url,
                shareable: att.shareable
            });
        });
    }

    render() {
        return (
            <div>
                <div style={{ display: 'inline-block' }}>{`${LocalizedStrings.attachments}: `}</div>
                <IconButton name="fa-plus" onClick={this.handleAddContentClick} />
                <Dialog
                    fullScreen={this.props.fullScreen}
                    fullWidth
                    maxWidth='md'
                    open={this.state.isContentPickerOpen}
                    onClose={this.handleCloseContentPicker}
                    classes={{
                        root: this.props.classes.root
                    }}
                >
                    <DialogTitle style={{ padding: '15px' }}>
                        {LocalizedStrings.attachments}
                    </DialogTitle>
                    <DialogContent style={{ padding: '0px' }}>
                        <ContentPicker
                            notify={this.props.notify}
                            onDataChange={this.onAttachmentsChange}
                            contents={this.state.tempAttachments}
                            shareContext={true}
                        />
                    </DialogContent>
                    <DialogActions>
                        <div style={{
                            display: 'inline-block',
                            position: 'absolute',
                            left: '15px',
                            bottom: '10px',
                            transition: '0.5s',
                            opacity: this.state.showFileAdded === true ? 1 : 0,
                            visibility: this.state.showFileAdded === true ? 'visible' : 'hidden',
                        }}>
                            <Chip label={LocalizedStrings.attachmentAdded} color="primary" />
                        </div>
                        {this.state.loadingDone === true ?
                            <div style={{
                                marginBottom: '15px',
                                marginRight: '20px'
                            }}>
                                <Loader loading={true} />
                            </div>
                            :
                            <Button variant="contained" onClick={this.prepareAttachmentsForShare}>
                                {LocalizedStrings.done}
                            </Button>
                        }
                    </DialogActions>
                </Dialog>
                <ContentPicker
                    notify={this.props.notify}
                    onDataChange={this.onAttachmentsChange}
                    contents={this.parseToResource(this.props.attachments)}
                    disabled={true}
                    shareContext={true}
                />
            </div>
        );
    }
}
AttachmentManager.propTypes = {
    fullScreen: PropTypes.bool.isRequired,
    classes: PropTypes.object.isRequired,
    notify: PropTypes.func.isRequired,
    attachments: PropTypes.array.isRequired,
    onAttachmentsChange: PropTypes.func.isRequired,
};

export default withStyles(styles)(withMobileDialog()(AttachmentManager));